type Props = {
  children: React.ReactNode;
};

export default function HeaderLayout({ children }: Props) {
  return (
    <div
      className="text-brand-gray bg-white p-2 max-w-[1200px] m-auto"
      data-testid="header-layout-section"
    >
      {children}
    </div>
  );
}
